import { DividerBlock } from "../blocks/layout/DividerBlock";
import { SpacerBlock } from "../blocks/layout/SpacerBlock";
import { TextBlock } from "../blocks/layout/TextBlock";
import { ContentRendererProps } from "./ContentRenderer.types";

/**
 * Dispatches a content config to its block, mirroring FieldRenderer - the two
 * are a pair, one for items bound to the record and one for items that aren't.
 */
export function ContentRenderer({ content }: ContentRendererProps) {
  switch (content.type) {
    case "text":
      return <TextBlock content={content.content} />;
    case "divider":
      return <DividerBlock />;
    case "spacer":
      return <SpacerBlock height={content.height} />;
    default:
      return null;
  }
}

export default ContentRenderer;
